import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { applyTheme } from './lib/theme';
import { initApp } from './native/shell';
import './fonts.css';
import './styles.css';
import './ui.css'; // компоненты дизайн-системы v2.2 (docs/design-system.md); подключён после styles.css, чтобы классы компонентов побеждали старые правила

// до первой отрисовки — иначе выбравший тёмную тему увидит вспышку светлой
applyTheme();
// в приложении iPhone: ссылки в Safari, файлы через «Поделиться», статус-бар под тему
initApp();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
